// API Configuration
const getApiUrl = (): string => {
  // Check if we're in development environment
  const isDevelopment =
    process.env.NODE_ENV === 'development' ||
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname.includes('dev');

  if (isDevelopment) {
    return 'http://localhost:8000/api';
  }

  // For production, use the environment variable or fallback
  return process.env.API_URL || '/api';
};

export const API_BASE_URL = getApiUrl();

// Helper function to create API URLs
export const createApiUrl = (endpoint: string): string => {
  // Remove leading slash if present to avoid double slashes
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${API_BASE_URL}/${cleanEndpoint}`;
};
